<template>
<div>
  <HeaderGestion/>
  <SubHeaderGestion nombreGestion="Memorias de congresos"/>
  <FormCongPonen/>
</div>
</template>

<script>
import HeaderGestion from '../components/HeaderGestion.vue'
import SubHeaderGestion from '../components/SubHeaderGestion.vue'
import FormCongPonen from '../components/FormCongPonen.vue'
export default {
  components: { HeaderGestion, SubHeaderGestion, FormCongPonen },
  name: 'GesMemorias',
  data () {
    return {
      gestion: 'Gestión colecciones'
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
</style>
